import { Component, OnInit, Input } from '@angular/core';

@Component({
	selector: 'loading',
	templateUrl: './loading.component.html',
	styleUrls: ['./loading.component.scss']
})
export class LoadingComponent implements OnInit {

	@Input('light') light: boolean;
	@Input('branded') branded: boolean;
	@Input('small') small: boolean;

	constructor() { }

	ngOnInit() {
	}

}
